<template>
  <v-dialog max-width="500px" persistent v-model="dialog" scrollable>
    <v-card>
      <v-toolbar dark>
        <v-toolbar-title class="headline">{{formTitle}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="cancel()">close</v-icon>
      </v-toolbar>
      <v-card-text style="height: auto;">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="form.product_type_name_th"
            @input="toUpper($event,'th')"
            label="Product Type Name TH"
            :rules="form.product_type_name_th ? [rules.max] : []"
            counter="55"
          ></v-text-field>
          <v-text-field
            v-model="form.product_type_name_en"
            @input="toUpper($event,'en')"
            label="Product Type Name EN"
            :rules="form.product_type_name_en ? [rules.max] : []"
            counter="55"
          ></v-text-field>
          <v-text-field
            v-model="form.product_type_name_cn"
            @input="toUpper($event,'cn')"
            label="Product Type Name CN"
            :rules="form.product_type_name_cn ? [rules.max] : []"
            counter="55"
          ></v-text-field>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" flat @click="cancel()">Cancel</v-btn>
        <v-btn color="green" :disabled="isEditProductList" flat @click="save()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  props: ["dialog", "editedIndex", "form"],
  data() {
    return {
      valid: true,
      rules: {
        max: value => value.length <= 55 || "Maximum length is 55 characters.",
        max_description: value =>
          value.length <= 255 || "Maximum length is 255 characters."
      }
    };
  },
  computed: {
    ...mapState({
      store_detail_id: state => state.storeBack.store_detail_id
    }),
    ...mapGetters(["isEditProductList"]),
    formTitle() {
      return this.editedIndex === -1 ? "New product type" : "Edit product type";
    }
  },
  methods: {
    toUpper(event, lang) {
      this.form["product_type_name_" + lang] = event.toUpperCase();
    },
    cancel() {
      this.$emit("setDialog", false);
      if (this.editedIndex != -1) {
        this.$emit("cancelEdit");
      }
      this.$emit("setEditIndex", -1);
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.$emit("setDialog", false);
        this.form.product_type_store_id = this.store_detail_id;
        delete this.form.product_type_count_product;
        if (this.editedIndex == -1) {
          this.$store.dispatch("fetchProductTypeBack/addType", this.form);
        } else {
          this.$emit("setEditIndex", -1);
          let check_success = await this.$store.dispatch(
            "fetchProductTypeBack/editType",
            this.form
          );
          if (check_success == false) {
            this.$emit("cancelEdit");
            return;
          }
          return;
        }
        this.$emit("setEditIndex", -1);
      }
    }
  }
};
</script>



